import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient } from '@angular/common/http';
import { School } from './../../../models/school';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';
const jsPDF = require('jspdf');
import * as QRCode from 'qrcode';
require('jspdf-autotable');

@Component({
  selector: 'app-school-datatable',
  templateUrl: './school-datatable.component.html',
  styleUrls: ['./school-datatable.component.css']
})
export class SchoolDatatableComponent implements OnInit, OnDestroy {

  filter = {
    clientId: '',
    cityWeatherId: '',
    name: ''
  };
  staticFilter: any;
  public clientsData: Array<Select2OptionData>;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  clients: any[];
  cityWeathers: any[];
  schools: any[];
  pnotify = undefined;
  SchoolLogoBase64 = "";
  SchoolCode = "";

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      let client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      //this.SchoolLogoBase64 = client.image;
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      let client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      //this.SchoolLogoBase64 = client.image;
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
      });
    }
    this.http.get(
      '/api/cityWeather/lookup'
    ).subscribe((cityWeathers: any[]) => {
      this.cityWeathers = cityWeathers;
    });
    this.staticFilter = this.filter;
    this.pnotify = pnotifyService.getPNotify();
  }
  clientChanged(e: any) {
    this.filter.clientId = e.value;
  }

  ngOnInit(): void {
    
    let columns = [
      { data: 'checkbox' },
      { data: 'name' },
      { data: 'codeSchool' },
      { data: 'cityWeatherCityName' },
      { data: 'actions' }
    ];
    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns = [
        { data: 'checkbox' },
        { data: 'name' },
        { data: 'codeSchool' },
        { data: 'clientName' },
        { data: 'cityWeatherCityName' },
        { data: 'creationDate' },
        { data: 'actions' }
      ];
    }
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/school',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.schools = resp.data;
          const dta = [];
          this.schools.forEach((school, index) => {
            const btnDelete = `<button class="btn btnAction btnDelete" data-school-id="${school.id}">
                                <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                              </button>`;

            dta.push({
              id: school.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${school.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              name: school.name,
              codeSchool: school.codeSchool,
              clientName: school.Client.name,
              cityWeatherCityName: school.CityWeather.cityName,
              actions: `
                <a class="btn btnAction btnNavigate" data-url="/school/view/${school.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                <a class="btn btnAction btnNavigate" data-url="/school/edit/${school.id}">
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                </a>
                <a class="btn btnAction btnCodeAppMobile"
                  data-school-name="${school.name}"
                  data-school-code="${school.codeSchool}"
                  data-school-image="${school.Client.image}">
                  <i class="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>Code App Mobile
                </a>
                ${(this.roleService.getRole('ROLE_ADMIN')) ? btnDelete : ''}
              `
            });

            if (this.roleService.getRole('ROLE_ADMIN')) {
              dta[index].creationDate = moment(school.creationDate).format('DD/MM/YYYY');
            }
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'school_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnCodeAppMobile', (event) => {
      const $target = $(event.currentTarget);
      const schoolName = $target.data('schoolName') || '';
      const schoolCode  = $target.data('schoolCode') || '';
      const schoolImage = $target.data('schoolImage');
    
      if (!schoolCode ) {
        console.warn('School code is missing. Cannot generate app code.');
        return;
      }
    
      this.onCreateCodeAppMobile(schoolName, schoolCode , schoolImage);
      
    });
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('schoolId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/school/' + id)
      .subscribe(
        result => {
          document.getElementById('school_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

    async onCreateCodeAppMobile(schoolName, schoolCode, schoolLogoBase64 ): Promise<void> {
      const doc = new jsPDF();

      console.log ("SchoolLogoBase64 => " + schoolLogoBase64);
      console.log ("SchoolCode => " + schoolCode);

      let offsetDocY = 0;
      let Dashline = 0;
      doc.setFontSize(11);
      //let schoolCode = '';
      let enteteMsg = `Le ${moment().format('DD-MM-YYYY')}`;
      const signature = 'La direction';
      
      // URLs to generate QR codes
      const playStoreURL = 'https://play.google.com/store/apps/details?id=com.inovsys.madar_stop&hl=fr';
      const appStoreURL = 'https://apps.apple.com/us/app/madarstop/id1642115740';

      const qrAndroid = await QRCode.toDataURL(playStoreURL);
      const qrApple = await QRCode.toDataURL(appStoreURL);

      const message_parent = `Chers parents,
Notre école utilise désormais l'application MADARSTOP pour le suivi en temps réel du transport scolaire de votre enfant.

Votre code d'établissement : %code%

IMPORTANT : Pour ajouter votre bus, contactez directement votre chauffeur qui vous communiquera le code bus nécessaire.
Téléchargez l'application :`;

      for (let index = 1; index <= 2; index++) { 
          
        if (index <= 2 && index % 2 === 0){
          offsetDocY = (doc.internal.pageSize.height/2);
          Dashline = 0;
          
        } else {
          offsetDocY = 0;
          Dashline = 1;
        }

        // Entete - consistent formatting for both sections
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0);
        doc.setFontSize(11);
        doc.text(10, offsetDocY + 20, enteteMsg);

        // Add the logo at the top right
        const logoWidth = 20; // Adjust the width of the logo
        const logoX = doc.internal.pageSize.width - logoWidth - 15; // Adjust the horizontal position
        const logoY = offsetDocY + 10; // Adjust the vertical position

        doc.addImage(schoolLogoBase64, 'JPEG', logoX, logoY, logoWidth, logoWidth);

        // Body
        const marginLeft = 10;
        const lineHeight = 5; // Reduced to 5 for tighter spacing
        let y = offsetDocY + 37; // Moved down from 32 to 37 (one more line below)

        let message = message_parent;
        message = message.replace('%code%', schoolCode);
        message = message.split('\n').map(line => line.trim()).join('\n'); // Supprime les espaces en début/fin de chaque ligne
        //const lines = doc.splitTextToSize(message, 180); // Adjust the width as needed

        const lines = message.split('\n');
        
        for (let line of lines) {
          if (line.includes(schoolCode)) {
            // Ligne avec le code - traiter le texte et le code sur la même ligne
            const parts = line.split(schoolCode);
            
            // Texte normal avant le code
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(0);
            doc.setFontSize(11);
            const textWidth = doc.getTextWidth(parts[0]);
            doc.text(parts[0], marginLeft, y);
            
            // Code en couleur et gras
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(0, 102, 204); // Bleu
            doc.setFontSize(16);
            doc.text(schoolCode, marginLeft + textWidth, y);
            
            y += lineHeight;
          } else if (line.includes("Téléchargez l'application :")) {
            // Skip this line since we'll add it separately below QR codes
            continue;
          } else {
            // Texte normal
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(0);
            doc.setFontSize(11);
            const wrapped = doc.splitTextToSize(line, 190);
            doc.text(wrapped, marginLeft, y);
            y += wrapped.length * lineHeight;
          }
        }

        // "Téléchargez l'application :" text positioned above QR codes
        const downloadTextY = y + 3; // Reduced from 8 to 3 (moved up by 5)
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0);
        doc.setFontSize(11);
        doc.text('Téléchargez l\'application :', marginLeft, downloadTextY);

        // QR codes positioned after download text
        const imageX = 15;
        const imageY = downloadTextY + 8; // Position QR codes below the download text
        const imageWidth = 30;
        const imageHeight = 30;

        // QR codes
        doc.addImage(qrAndroid, 'PNG', imageX, imageY, imageWidth, imageHeight);
        doc.text('Android', imageX + 8, imageY + imageHeight + 5);

        doc.addImage(qrApple, 'PNG', imageX + imageWidth + 20, imageY, imageWidth, imageHeight);
        doc.text('iOS', imageX + imageWidth + 20 + (imageWidth / 2) - 5, imageY + imageHeight + 5);

        // Signature
        const signatureX = doc.internal.pageSize.width - 40;
        const signatureY = imageY + imageHeight + 15; // Moved down from 10 to 15 (one step down)
        
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(0);
        doc.setFontSize(11);
        doc.text(signatureX, signatureY, signature);

        // Copyright footer - centered in the section
        const copyrightY = signatureY + 8; // Moved down from 6 to 8 (one step down)
        const currentYear = new Date().getFullYear();
        const copyrightText = `© MadarStop ${currentYear} - Transport Scolaire Intelligent`;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150); // Grey color
        doc.text(copyrightText, doc.internal.pageSize.width / 2, copyrightY, { align: 'center' });

        if (Dashline){
          // Draw dashed line in the middle
          const lineWidth = doc.internal.pageSize.width - 20; // Adjust line width
          const lineHeight = 0.3; // Adjust line height
          const lineX = 10; // Adjust X position
          const lineY = (doc.internal.pageSize.height / 2) - (lineHeight / 2); // Middle Y position

          const dashLength = 3; // Adjust the length of dashes
          const spaceLength = 1; // Adjust the length of spaces

          let xPos = lineX;
          let drawDash = true;

          while (xPos < lineX + lineWidth) {
              if (drawDash) {
                  doc.setDrawColor(0); // Set color to black
                  doc.setLineWidth(lineHeight);
                  doc.line(xPos, lineY, xPos + dashLength, lineY);
                  xPos += dashLength;
              } else {
                  xPos += spaceLength;
              }

              drawDash = !drawDash;
          }
        }
        
        
    };
    
      // Save
      doc.save(`CodeAppMobile-${schoolName}.pdf`);
    }
    

  onFilter(): void {
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/school/school-datatable/school-datatable.component.ts